import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const rewardsHomeRoute: RouteConfig<'with-page'> = {
    name: 'Explore Rewards',
    page: lazy(() => import('.')),
    path: '/rewards/home',
    flags: ['member-route'],
    permissions: ['rewards'],
    context:'member'
}